import type { PackerOrder } from "@/hooks/usePackers";

type CorrectionEntry = {
  product_id: string;
  product_naam: string;
  eenheid: string;
};

const correctionsMap = new Map<string, CorrectionEntry>();

export function cacheCorrection(ordernumber: string, lineitemindex: number, bp: CorrectionEntry) {
  correctionsMap.set(`${ordernumber}-${lineitemindex}`, bp);
}

export function applyCorrections(orders: PackerOrder[]): PackerOrder[] {
  if (correctionsMap.size === 0) return orders;
  return orders.map(order => ({
    ...order,
    line_items: order.line_items.map(li => {
      const cached = correctionsMap.get(`${order.ordernumber}-${li.lineitemindex}`);
      if (cached && !li.base_paint?.booking_product) {
        return { ...li, base_paint: { ...li.base_paint!, booking_product: cached } };
      }
      return li;
    }),
  }));
}
